import { render, staticRenderFns } from "./ProPlanAdvantages.vue?vue&type=template&id=6420fb68&scoped=true&"
import script from "./ProPlanAdvantages.vue?vue&type=script&lang=js&"
export * from "./ProPlanAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./ProPlanAdvantages.vue?vue&type=style&index=0&id=6420fb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6420fb68",
  null
  
)

export default component.exports